import React from 'react';
import type { SessionScreen } from '../../../features/flow/session';

/** Non-illustration screens with only paragraphs / bullets (no question grid). */
export function ParagraphsScreenBody({ sessionScreen }: { sessionScreen: SessionScreen }) {
  return (
    <>
      {sessionScreen.paragraphs && sessionScreen.paragraphs.length > 0 ? (
        <p className="text-[#525353] text-base w-full max-w-[416px] font-medium text-left">
          <ul className="list-disc list-inside">
            {sessionScreen.paragraphs.map((paragraph) => (
              <li key={paragraph}>{paragraph}</li>
            ))}
          </ul>
        </p>
      ) : null}

      {sessionScreen.bullet_points && sessionScreen.bullet_points.length > 0 ? (
        <p className="text-[#525353] text-base w-full max-w-[416px] font-medium text-left">
          <ul className="list-disc list-inside">
            {sessionScreen.bullet_points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </p>
      ) : null}
    </>
  );
}
